var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99989 17.5C9.99989 17.5 16.2205 13.8527 16.2205 8.72059C16.2205 5.28506 13.4354 2.5 9.99989 2.5C6.56436 2.5 3.7793 5.28506 3.7793 8.72059C3.7793 13.8527 9.99989 17.5 9.99989 17.5Z",
    stroke: "#919191",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2617 8.62365C12.2617 9.87302 11.2489 10.8859 9.99952 10.8859C8.75012 10.8859 7.7373 9.87302 7.7373 8.62365C7.7373 7.37427 8.75012 6.36143 9.99952 6.36143C11.2489 6.36143 12.2617 7.37427 12.2617 8.62365Z",
    fill: "#919191"
  })));
};
export default SvgLocation;